import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { requestKeycloakRegistration } from '../../../api/registration/registration.actions';

import KeycloakRegistration from '../../../components/screens/auth/keycloak-registration/KeycloakRegistration';

const KeycloakRegistrationContainer = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { personExternalReference } = useParams();

  const [searchParams] = useSearchParams();

  const keyUUID = searchParams.get('keyExternalReference');

  const determineNavigation = () => {
    if (keyUUID === null) {
      navigate(`/registration/${personExternalReference}`);
    } else {
      navigate(`/registration/${personExternalReference}?keyExternalReference=${keyUUID}`);
    }
  };

  const registerKeycloak = (details) => {
    dispatch(
      requestKeycloakRegistration({
        keycloakRegistration: {
          ...details,
          personExternalReference,
        },
        onSuccess: () => determineNavigation(),
      })
    );
  };

  return <KeycloakRegistration register={registerKeycloak} />;
};

export default KeycloakRegistrationContainer;
